import { Check, ChevronRight, Tag } from "lucide-react";
import { CATEGORIES } from "../data/catalog";
import { formatBRL, periodicitySuffix } from "../lib/format";
import { planCardNote } from "../lib/planCardNotes";
import { Plan } from "../types";
import "./ProductCard.css";

export interface ProductCardProps {
  plan: Plan;
  onSubscribe: (plan: Plan) => void;
  onDetails: (plan: Plan) => void;
  loading?: boolean;
}

export function categoryLabel(plan: Plan): string {
  return CATEGORIES.find((c) => c.id === plan.categoryId)?.label ?? "";
}

export function ProductCard({ plan, onSubscribe, onDetails, loading = false }: ProductCardProps) {
  const category = categoryLabel(plan);
  const note = planCardNote(plan.name);
  const period = periodicitySuffix(plan.periodicityId);

  return (
    <article className="plan-card">
      {category ? <p className="plan-card-category">{category}</p> : null}
      <h3 className="plan-card-name">{plan.name}</h3>
      <p className="plan-card-description">{plan.description}</p>
      {plan.benefits.length > 0 ? (
        <ul className="plan-card-features">
          {plan.benefits.map((benefit) => (
            <li key={benefit} className="plan-card-feature">
              <Check aria-hidden className="plan-card-feature-icon" size={18} />
              <span className="plan-card-feature-label">{benefit}</span>
            </li>
          ))}
        </ul>
      ) : null}
      {note !== null ? <p className="plan-card-note">{note}</p> : null}
      <div className="plan-card-spacer" />
      <div className="plan-card-divider" />
      <p className="plan-card-price-row">
        <span className="plan-card-price">{formatBRL(plan.price)}</span>
        {period ? <span className="plan-card-period">{period}</span> : null}
      </p>
      <p className="plan-card-caption">
        <Tag aria-hidden className="plan-card-caption-icon" size={14} />
        Preço atual do site
      </p>
      <div className="plan-card-actions">
        <button
          type="button"
          className="plan-card-subscribe"
          disabled={loading}
          aria-busy={loading ? true : undefined}
          onClick={() => onSubscribe(plan)}
        >
          Assinar
        </button>
        <button
          type="button"
          id={`ver-detalhes-${plan.id}`}
          className="plan-card-details"
          onClick={() => onDetails(plan)}
        >
          Ver detalhes
          <ChevronRight aria-hidden className="plan-card-details-icon" size={18} />
        </button>
      </div>
    </article>
  );
}
